import React, { useState, useEffect } from 'react';
import { Modal, Button, Checkbox, Col, Row } from 'antd';

import { getStatisticsResults, getProject } from 'services/project';
import { getAnalysisData } from 'services/second_sider_analysis';

import background_circle_blue_modal from 'images/background_circle_blue_modal.svg';

import icon_settings from 'images/icon_settings.svg';
import settings from 'images/new_pop_ups/settings.svg';

const SelectDataToDisplay = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [analysisResults, setAnalysisResults] = useState([]);
    const [checkedList, setCheckedList] = useState([]);
    const [defaultStatistics, setDefaultStatistics] = useState([]);

    const [statisticsFromServer, setStatisticsFromServer] = useState([]);

    const showModal = () => {
        setIsModalVisible(true);
        if (
            props.analysis.analysisData[
                props.analysisId
            ].variables.hasOwnProperty('settings') &&
            props.analysis.analysisData[
                props.analysisId
            ].variables.settings.hasOwnProperty('statistics')
        ) {
            setCheckedList(
                props.analysis.analysisData[props.analysisId].variables.settings
                    .statistics
            );
        }
    };

    const handleOk = () => {
        setIsModalVisible(false);
        props.handleSetStatistics(props.analysisId, checkedList);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    let activeProject = localStorage.getItem('activeProject');

    useEffect(() => {
        getStatisticsResults()
            .then((res) => {
                setAnalysisResults(res.data.results);
                let defaultSelectStatistics = res.data.results.flatMap(
                    (item) => {
                        if (item.name && item.default) {
                            return [item.name];
                        }
                        return [];
                    }
                );
                setDefaultStatistics(defaultSelectStatistics);

                setCheckedList(defaultSelectStatistics);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    let plainOptions = [...analysisResults];

    let testfor = [...plainOptions];

    const onChange = (checkedValues) => {
        setCheckedList(checkedValues);
    };

    const [clickAllButton, setClickAllButton] = useState(false);
    const [clickDefaultButton, setClickDefaultButton] = useState(true);
    const [clickCustomButton, setClickCustomButton] = useState(false);

    const handleAllButton = () => {
        setClickAllButton(true);
        setClickDefaultButton(false);
        setClickCustomButton(false);

        let defaultSelectStatistics = analysisResults.flatMap((item) => {
            if (item.name) {
                return [item.name];
            }
            return [];
        });
        setCheckedList(defaultSelectStatistics);
    };

    const handleDefaultButton = () => {
        setClickDefaultButton(true);
        setClickAllButton(false);
        setClickCustomButton(false);
        setCheckedList(defaultStatistics);
    };

    const handleCustomButton = () => {
        setClickCustomButton(true);
        setClickAllButton(false);
        setClickDefaultButton(false);
        setCheckedList([]);
    };

    const checkDifferenceBetweenState = (checkedList, defaultStatistics) => {
        // if (statisticsFromServer === '') {
        if (
            JSON.stringify(checkedList) !== JSON.stringify(defaultStatistics) &&
            checkedList.length < 18
        ) {
            setClickCustomButton(true);
            setClickAllButton(false);
            setClickDefaultButton(false);
        } else if (
            JSON.stringify(checkedList) === JSON.stringify(defaultStatistics)
        ) {
            setClickCustomButton(false);
            setClickAllButton(false);
            setClickDefaultButton(true);
        } else if (JSON.stringify(checkedList.length) === '18') {
            setClickCustomButton(false);
            setClickAllButton(true);
            setClickDefaultButton(false);
        }
    };

    let columnLength = Math.ceil(plainOptions.length / 3);

    let tableBody = [];

    for (let i = 1; i <= 3; i++) {
        let colBody = [];
        for (let j = 1; j <= columnLength; j++) {
            if (plainOptions.length) {
                colBody.push(
                    <Checkbox
                        key={i}
                        className="checkbox-font-and-size"
                        value={plainOptions[0].name}
                    >
                        {plainOptions[0].display_name}
                    </Checkbox>
                );
                plainOptions.shift();
            }
        }
        let classname = '';
        if (i == 2) {
            classname = 'col1';
        }
        tableBody.push(
            // <Col
            //     className={classname}
            //     style={{ display: 'flex', flexDirection: 'column' }}
            //     span={8}
            // >
            //     {colBody}
            // </Col>
            <div
                key={i}
                className={classname}
                style={{ display: 'flex', flexDirection: 'column' }}
                span={8}
            >
                {colBody}
            </div>
        );
    }

    useEffect(() => {
        checkDifferenceBetweenState(checkedList, defaultStatistics);
    }, [checkedList]);

    return (
        <>
            {/* <Button style={{position: 'absolute',right: '0',top: '279px', display: 'block', marginBottom: '30px'}} type="primary" onClick={showModal}>
                Open Modal
                    </Button> */}
            <img
                src={icon_settings}
                style={{
                    height: '15px',
                    marginBottom: '32px',
                    cursor: 'pointer'
                }}
                onClick={showModal}
            />
            <Modal
                className="custom-modal-select-data-display"
                title=""
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                closable={false}
                bodyStyle={{ padding: '40px 0px' }}
                width={693}
            >
                <div className="icon-container">
                    {/* <img
                        className="img-icon-container"
                        src={background_circle_blue_modal}
                    />
                    <img className="icon-in-green-circle" src={icon_settings} /> */}
                    <img
                        src={settings}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div
                        style={{
                            textAlign: 'center'
                        }}
                    >
                        <p
                            className="header-title"
                            style={{ marginBottom: 53 }}
                        >
                            Select data to display in statistics table
                        </p>
                    </div>
                    <div className="selected-data-button-container">
                        <div className="box">
                            <button
                                className={
                                    clickAllButton
                                        ? 'button-selected'
                                        : 'button-unselected'
                                }
                                onClick={handleAllButton}
                            >
                                ALL
                            </button>
                            <button
                                className={
                                    clickDefaultButton
                                        ? 'button-selected'
                                        : 'button-unselected'
                                }
                                onClick={handleDefaultButton}
                            >
                                DEFAULT
                            </button>
                            <button
                                className={
                                    clickCustomButton
                                        ? 'button-selected'
                                        : 'button-unselected'
                                }
                                onClick={handleCustomButton}
                            >
                                CUSTOM
                            </button>
                        </div>
                    </div>
                    <div className="table-body-sdtd">
                        <Checkbox.Group
                            options={plainOptions}
                            style={{ width: '100%', display: 'flex' }}
                            onChange={onChange}
                            value={checkedList}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%'
                                }}
                            >
                                {tableBody}
                            </div>
                        </Checkbox.Group>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            marginTop: '40px'
                        }}
                    >
                        <button
                            onClick={handleOk}
                            style={{ width: 247, height: 26 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                        <Button
                            onClick={handleCancel}
                            style={{ width: 247, height: 26, marginTop: 10 }}
                        >
                            CANCEL
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default SelectDataToDisplay;
